/*
 * This is a customized version of SyncLoader of react-spinners library.
 * https://github.com/davidhu2000/react-spinners/blob/master/src/SyncLoader.tsx
 *
 * The react-spinners library is licensed under MIT license.
 * https://github.com/davidhu2000/react-spinners/blob/master/LICENSE
 */

import type { FC } from 'react'

import styled, { css, keyframes } from 'styled-components'
import { useIsClientSide } from 'utils/hooks/use-is-client-side'

const sync = keyframes`
  33% { transform: translateY(10px) }
  66% { transform: translateY(-10px) }
  100% { transform: translateY(0) }
`

const animationName = css`
  > span {
    animation-name: ${sync};
  }
`

interface Props {
  className?: string
  color: string
  'data-test-id'?: string
}

const SyncLoaderComponent: FC<Props> = ({ className, 'data-test-id': dataTestId }) => {
  const isClient = useIsClientSide()
  return isClient ? (
    <span className={className} data-test-id={dataTestId}>
      <span />
      <span />
      <span />
    </span>
  ) : null
}

SyncLoaderComponent.displayName = 'SyncLoader'

export const SyncLoader = styled(SyncLoaderComponent)(
  ({ color }) => ({
    '> span': {
      animation: '0.6s infinite ease-in-out both',
      backgroundColor: color,
      borderRadius: '100%',
      display: 'inline-block',
      height: 15,
      margin: 2,
      width: 15,

      '&:nth-child(1)': { animationDelay: `0.07s` },
      '&:nth-child(2)': { animationDelay: `${2 * 0.07}s` },
      '&:nth-child(3)': { animationDelay: `${3 * 0.07}s` },
    },
  }),
  animationName,
)
